import { authTokenApiSlice } from "src/api/auth-token-ApiSlice";
import { RootState, store } from "src/app/store";

export const useFileDownload = () => {
  const state = store.getState() as RootState;

  const fetchData = async (request: any, url: string, fileName: string) => {
    const token = authTokenApiSlice.endpoints.getAuthKey.select()(state).data!!.token;
    const headers = new Headers(
        {"Authorization": `Bearer ${token}`, "Content-Type": 'application/json'}
    );
    try {
      const response = await fetch(
          url,
          {
            headers,
            method: 'POST',
            body: JSON.stringify(request),
            mode: 'cors'
          } as RequestInit
      );
      const blob = await response.blob();
      const downLoadUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = downLoadUrl;
      link.download = fileName;
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(downLoadUrl);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
    }
  };
  return {fetchData};
}

function getErrorMessage(error: unknown) {
  if (error instanceof Error) return `${error.message} Could not Fetch Data `
  return `${error} Could not Fetch Data `
}
